<!-- Do not change this file. -->
<template>
  <div>
    <AlertLoading class="mt-5" v-if="!isReady" />
    <div v-else class="h-100">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { readEntry, readEntries } from "@/apis/datastore.js";
import { readGroups } from "@/apis/group.js";
import { readContentEntries } from "@/apis/content";
import {
  mapAchievementsFromSheet,
  mapQuestionsFromSheet,
  mapAwardedGroupPoints
} from "@/helpers/mapper.js";

import AlertLoading from "@/components/core/AlertLoading.vue";

export default {
  name: "APIHandler",
  components: {
    AlertLoading
  },
  computed: {
    ...mapState("datastore", ["entryLoaded", "entriesLoaded"]),
    ...mapState("groups", ["groupsLoaded"]),
    ...mapState("content", ["achievementsLoaded", "questionsLoaded"]),
    ...mapGetters([
      "getAchievementsApiKey",
      "getQuestionsApiKey",
      "getAwardedPointsApiKey"
    ]),
    isReady() {
      const meta = this.$route.meta;

      // Does this view need the current user's data?
      //   If so, wait until it is loaded.
      if (meta?.readEntry && !this.entryLoaded) {
        return false;
      }

      // Does this view need all users data?
      //   If so, wait until it is loaded.
      else if (meta?.readEntries && !this.entriesLoaded) {
        return false;
      }

      // Does this view need user groups?
      //   If so, wait until it is loaded.
      else if (meta?.readGroups && !this.groupsLoaded) {
        // return false;
      }

      // Does this view need content data?
      //   If so, wait until it is loaded.
      else if (
        meta?.readContent &&
        !this.achievementsLoaded &&
        !this.questionsLoaded
      ) {
        // Content is loaded on app init, so we are always ready here
        return false;
      }

      // We are not waiting on anything.
      // we are ready to render the view

      return true;
    }
  },
  methods: {
    ...mapActions(["mapFromDatastore"]),
    ...mapActions("datastore", ["setEntry", "setEntries"]),
    ...mapActions("groups", ["setGroups"]),
    ...mapActions("content", [
      "setAchievements",
      "setQuestions",
      "setAwardedPoints"
    ]),
    fetchContent() {
      const meta = this.$route.meta;

      if (meta?.readContent) {
        //console.log("[APIHandler] readContent");

        let achievementsAPI = this.getAchievementsApiKey;
        let questionsAPI = this.getQuestionsApiKey;
        let pointsAPI = this.getAwardedPointsApiKey;

        // Content is loaded on app init, no need to do anything here
        // Populate achievements from the content sheet
        readContentEntries("Submissions", achievementsAPI).then((payload) => {
          let mappedAchievements = mapAchievementsFromSheet(
            payload.data.message
          );
          this.setAchievements(mappedAchievements);
        });

        // Populate questions from the content sheet
        readContentEntries("Submissions", questionsAPI).then((payload) => {
          let mappedQuestions = mapQuestionsFromSheet(payload.data.message);
          this.setQuestions(mappedQuestions);
        });

        // Populate awarded points from the content sheet
        readContentEntries("Submissions", pointsAPI).then((payload) => {
          let mappedGroupPoints = mapAwardedGroupPoints(payload.data.message);
          this.setAwardedPoints(mappedGroupPoints);
        });
      }

      //if (meta?.readGroups) {
      //  readGroups().then((payload) => {
      //    this.setGroups(payload.data.message.groups);
      //  });
      // }
    }
  },
  watch: {
    $route() {
      const meta = this.$route.meta;

      //console.log("[APIHandler] route changed", this.$route.path, meta);

      // Does the current route need to load an entry or entries?
      // If so, load the entry, and map into Vuex
      if (meta?.readEntry) {
        readEntry().then((payload) => {
          this.setEntry(payload.data.message.entry.value);
          this.mapFromDatastore(payload.data.message.entry.value);

          this.fetchContent();
        });
      }
      if (meta?.readEntries) {
        readEntries().then((payload) => {
          this.setEntries(payload.data.message.entry);
        });
      }
    }
  }
};
</script>
